// extracted by mini-css-extract-plugin
module.exports = {"solar-60w-K":"K_solar-60w-K__JFOo_"};